import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import TextField from "@mui/material/TextField";
import ReactInputMask from "../../ReactInputMask/index.js";
import { Preloader } from "../common/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TextFieldMasked_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TextFieldMasked_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const TextFieldMasked = (t0)=>{
    const $ = c(59);
    let InputLabelProps;
    let InputProps;
    let classes;
    let error;
    let helperText;
    let id;
    let inputProps;
    let loading;
    let mask;
    let name;
    let onChange;
    let placeholder;
    let rest;
    if ($[0] !== t0) {
        ({ id, mask, name, error, helperText, placeholder, loading, onChange, inputProps, InputProps, InputLabelProps, classes } = t0), rest = _object_without_properties(t0, [
            "id",
            "mask",
            "name",
            "error",
            "helperText",
            "placeholder",
            "loading",
            "onChange",
            "inputProps",
            "InputProps",
            "InputLabelProps",
            "classes"
        ]);
        $[0] = t0;
        $[1] = InputLabelProps;
        $[2] = InputProps;
        $[3] = classes;
        $[4] = error;
        $[5] = helperText;
        $[6] = id;
        $[7] = inputProps;
        $[8] = loading;
        $[9] = mask;
        $[10] = name;
        $[11] = onChange;
        $[12] = placeholder;
        $[13] = rest;
    } else {
        InputLabelProps = $[1];
        InputProps = $[2];
        classes = $[3];
        error = $[4];
        helperText = $[5];
        id = $[6];
        inputProps = $[7];
        loading = $[8];
        mask = $[9];
        name = $[10];
        onChange = $[11];
        placeholder = $[12];
        rest = $[13];
    }
    let inputPropsRest;
    let inputRef;
    let onBlur;
    let onFocus;
    let onKeyDown;
    let onMouseDown;
    let value;
    if ($[14] !== inputProps) {
        ({ value, onFocus, onBlur, onMouseDown, onKeyDown, ref: inputRef } = inputProps), inputPropsRest = _object_without_properties(inputProps, [
            "value",
            "onFocus",
            "onBlur",
            "onMouseDown",
            "onKeyDown",
            "ref"
        ]);
        $[14] = inputProps;
        $[15] = inputPropsRest;
        $[16] = inputRef;
        $[17] = onBlur;
        $[18] = onFocus;
        $[19] = onKeyDown;
        $[20] = onMouseDown;
        $[21] = value;
    } else {
        inputPropsRest = $[15];
        inputRef = $[16];
        onBlur = $[17];
        onFocus = $[18];
        onKeyDown = $[19];
        onMouseDown = $[20];
        value = $[21];
    }
    let t1;
    if ($[22] !== inputProps || $[23] !== onChange) {
        t1 = (event)=>{
            var _inputProps_onChange;
            onChange(event, event.target.value);
            null == (_inputProps_onChange = inputProps.onChange) || _inputProps_onChange.call(inputProps, event);
        };
        $[22] = inputProps;
        $[23] = onChange;
        $[24] = t1;
    } else t1 = $[24];
    const handleChange = t1;
    let t2;
    if ($[25] !== inputPropsRest) {
        t2 = _object_spread({}, inputPropsRest);
        $[25] = inputPropsRest;
        $[26] = t2;
    } else t2 = $[26];
    let t3;
    if ($[27] !== loading) {
        t3 = loading ? {
            endAdornment: /*#__PURE__*/ jsx(Preloader, {})
        } : {};
        $[27] = loading;
        $[28] = t3;
    } else t3 = $[28];
    let t4;
    if ($[29] !== InputProps || $[30] !== t3) {
        t4 = _object_spread({}, InputProps, t3);
        $[29] = InputProps;
        $[30] = t3;
        $[31] = t4;
    } else t4 = $[31];
    let t5;
    if ($[32] !== InputLabelProps) {
        t5 = _object_spread({}, InputLabelProps);
        $[32] = InputLabelProps;
        $[33] = t5;
    } else t5 = $[33];
    let t6;
    if ($[34] !== t2 || $[35] !== t4 || $[36] !== t5) {
        t6 = {
            htmlInput: t2,
            input: t4,
            inputLabel: t5
        };
        $[34] = t2;
        $[35] = t4;
        $[36] = t5;
        $[37] = t6;
    } else t6 = $[37];
    let t7;
    if ($[38] !== classes || $[39] !== error || $[40] !== helperText || $[41] !== id || $[42] !== inputRef || $[43] !== name || $[44] !== placeholder || $[45] !== rest || $[46] !== t6) {
        t7 = /*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({}, rest), {
            id: id,
            inputRef: inputRef,
            name: name,
            classes: classes,
            autoComplete: "off",
            variant: "outlined",
            fullWidth: true,
            error: error,
            helperText: helperText,
            placeholder: placeholder,
            slotProps: t6
        }));
        $[38] = classes;
        $[39] = error;
        $[40] = helperText;
        $[41] = id;
        $[42] = inputRef;
        $[43] = name;
        $[44] = placeholder;
        $[45] = rest;
        $[46] = t6;
        $[47] = t7;
    } else t7 = $[47];
    let t8;
    if ($[48] !== handleChange || $[49] !== mask || $[50] !== name || $[51] !== onBlur || $[52] !== onFocus || $[53] !== onKeyDown || $[54] !== onMouseDown || $[55] !== rest.disabled || $[56] !== t7 || $[57] !== value) {
        t8 = /*#__PURE__*/ jsx(ReactInputMask, {
            value: value,
            onFocus: onFocus,
            onBlur: onBlur,
            onMouseDown: onMouseDown,
            onKeyDown: onKeyDown,
            mask: mask,
            name: name,
            onChange: handleChange,
            disabled: rest.disabled,
            children: t7
        });
        $[48] = handleChange;
        $[49] = mask;
        $[50] = name;
        $[51] = onBlur;
        $[52] = onFocus;
        $[53] = onKeyDown;
        $[54] = onMouseDown;
        $[55] = rest.disabled;
        $[56] = t7;
        $[57] = value;
        $[58] = t8;
    } else t8 = $[58];
    return t8;
};
export { TextFieldMasked };
